import * as yup from "yup";
import { Max, Min, Validation } from "../../utils/Validation.utils";
export const TherapySubCategoryInitialValues = {
    therapy_category_id: "",
    name: ""
};
export const TherapySubCategorySchema = yup.object().shape({
    therapy_category_id: yup.string().required(Validation.Required),
    name: yup
        .string()
        .min(Min.Name, Validation.Min)
        .max(Max.LongName, Validation.Max)
        .required(Validation.Required)
});
